export const APPOINTMENT_DETAILS_DATA_REFRESH_TIMER = 30000; 
export const DEFAULT_RATE_VALUE = 5;
